import React, { lazy, Suspense } from "react";
import "./App.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import Loader from "./Utils/Loader/Loader";
import PageMiss from "./404/404";

const Home = lazy(() => import(/* webpackChunkName: "home" */ "./Home/Home"));
const About = lazy(() => import(/* webpackChunkName: "about-us" */ "./About/About"));
const Commitee = lazy(() => import(/* webpackChunkName: "commitee" */ "./Commitee/Commitee"));
const Gallery = lazy(() => import(/* webpackChunkName: "gallery" */ "./Gallery/Gallery"));
const Publications = lazy(() => import(/* webpackChunkName: "publications"  */ "./Pubications/Publications"));
const Downloads = lazy(() => import(/* webpackChunkName: "downloads" */ "./Downloads/Downloads"));
const ByeLaws = lazy(() => import(/* webpackChunkName: "bye-laws" */ "./ByeLaws/ByeLaws"));
const Membership = lazy(() => import(/* webpackChunkName: "membership" */ "./Membership/Membership"));
const Voting = lazy(() => import(/* webpackChunkName: "voting" */ "./Voting/Voting"));
const CastVote = lazy(() => import(/* webpackChunkName: "cast-vote" */ "./CastVote/CastVote"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#1a365d",
    },
    secondary: {
      main: "#C99ACB",
    },
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/about-us" component={About} />
              <Route path="/commitee" component={Commitee} />
              <Route path="/gallery" component={Gallery} />
              <Route path="/publications" component={Publications} />
              <Route path="/downloads" component={Downloads} />
              <Route path="/constitution-byelaws" component={ByeLaws} />
              <Route path="/become-member" component={Membership} />
              <Route path="/voting" component={Voting} />
              <Route path="/cast-vote" component={CastVote} />

              <Route component={PageMiss} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
